import styles from './ProfileItemLabel.module.scss';

type Props = {
  label: string;
  classes?: string;
};

const ProfileItemLabel = ({ label, classes }: Props) => {
  return <span className={`${styles.host} ${classes}`}>{label}</span>;
};

export default ProfileItemLabel;
